module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "incident"
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('INCIDENTS')))])]), _vm._v(" "), _c('div', {
    ref: "filter",
    staticClass: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('CHOOSEFILTERBY')
    },
    on: {
      "change": _vm.changedFilter
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return (item.value != _vm.active_filter) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), (_vm.active_filter == 'monitor') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYSUPERVISOR'),
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getIncidents(true)
      }
    },
    model: {
      value: (_vm.BusMonitorID),
      callback: function($$v) {
        _vm.BusMonitorID = $$v
      },
      expression: "BusMonitorID"
    }
  }, _vm._l((_vm.monitors), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": _vm._FullName({
          NameEN: item.FullName_EN,
          NameAR: item.FullName_AR
        }),
        "value": item.BusMonitorID
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'bus') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYBUS'),
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getIncidents(true)
      }
    },
    model: {
      value: (_vm.BusID),
      callback: function($$v) {
        _vm.BusID = $$v
      },
      expression: "BusID"
    }
  }, _vm._l((_vm.buses), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Label,
        "value": item.BusID
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'type') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYTYPE'),
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getIncidents(true)
      }
    },
    model: {
      value: (_vm.TypeIncidentID),
      callback: function($$v) {
        _vm.TypeIncidentID = $$v
      },
      expression: "TypeIncidentID"
    }
  }, _vm._l((_vm.incidentTypes), function(item, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'status') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('FILTERBYSTATUS'),
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getIncidents(true)
      }
    },
    model: {
      value: (_vm.Status),
      callback: function($$v) {
        _vm.Status = $$v
      },
      expression: "Status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('OPEN'),
      "value": "Open"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "danger",
      "close-transition": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('OPEN')))])], 1), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('REPORTED'),
      "value": "Reported"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "warning",
      "close-transition": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('REPORTED')))])], 1), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('RESOLVED'),
      "value": "Resolved"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "success",
      "close-transition": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('RESOLVED')))])], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.new_page || _vm.loading),
      expression: "new_page || loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.incidents[_vm.currentPage - 1],
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('BUSSUPERVISOR'),
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n           " + _vm._s(_vm._FullName({
          NameEN: scope.row.monitor.FullName_EN,
          NameAR: scope.row.monitor.FullName_AR
        })) + " "), _c('br'), _c('small', [_vm._v(_vm._s(scope.row.Timestamp))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('BUS'),
      "prop": "bus.Label"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('STUDENTS'),
      "width": "180",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.student_id.length) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('STATUS'),
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm.status[scope.row.statusColor]
          }
        }, [_vm._v("\n            " + _vm._s(_vm.reportStatus[scope.row.statusColor]) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": "firstUpper",
      "label": _vm.$t('TYPE')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm.$t(scope.row.incident_type)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('VIEWINCIDENTDETAILS'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "small"
          },
          on: {
            "click": function($event) {
              _vm.showIncident(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-info-circle"
        }), _vm._v(" " + _vm._s(_vm.$t('DETAILS')))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isAllowed('flag', 'report/incident')) ? _c('el-tooltip', {
          attrs: {
            "content": scope.row.IsSticky ? _vm.$t('UNSTICK') : _vm.$t('STICK'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.flagItem(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.IsSticky ? 'fa-flag text-danger' : 'fa-flag-o']
        })])], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    ref: "pagination",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 30, 50, 70, 100],
      "page-size": _vm.limit,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.totalIncidents
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-incident-dialog', {
    attrs: {
      "incident": _vm.incident,
      "visible": _vm.incidentBox
    },
    on: {
      "update:visible": function($event) {
        _vm.incidentBox = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c770fcfa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/Incident.vue
// module id = 626
// module chunks = 1